import getIn from 'transmute/getIn';
import { TYPE } from '../../common-message-format/constants/keyPaths';
import { QUICK_REPLIES } from '../../common-message-format/constants/attachmentTypes';
import { getAttachments } from '../../common-message-format/operators/getAttachments';
export const isQuickRepliesAttachment = attachment => getIn(TYPE, attachment) === QUICK_REPLIES;
export const getQuickRepliesAttachment = message => {
  const attachments = getAttachments(message);
  if (!attachments || attachments.size === 0) return null;
  return attachments.find(isQuickRepliesAttachment) || null;
};